import React from 'react';

export const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.8055 10.2275C19.8055 9.51805 19.7499 8.83527 19.6277 8.17139H10.2002V12.0608H15.6013C15.3568 13.3386 14.6346 14.4275 13.5679 15.1664V17.7219H16.8124C18.7068 15.9664 19.8055 13.3386 19.8055 10.2275Z"
      fill="#4285F4"
    />
    <path
      d="M10.2002 20.2222C12.958 20.2222 15.2679 19.3111 16.8124 17.7222L13.5679 15.1667C12.6679 15.7889 11.5235 16.1556 10.2002 16.1556C7.53909 16.1556 5.28909 14.3778 4.50131 11.9778H1.15686V14.6111C2.69464 17.6667 6.19464 20.2222 10.2002 20.2222Z"
      fill="#34A853"
    />
    <path
      d="M4.50131 11.9778C4.29464 11.3556 4.17798 10.6889 4.17798 10.0001C4.17798 9.31117 4.29464 8.64451 4.50131 8.02228V5.38895H1.15686C0.422976 6.85562 0.000198364 8.48339 0.000198364 10.0001C0.000198364 11.5167 0.422976 13.1445 1.15686 14.6112L4.50131 11.9778Z"
      fill="#FBBC05"
    />
    <path
      d="M10.2002 3.84444C11.6457 3.84444 12.9346 4.35556 13.958 5.34444L16.8902 2.41111C15.2679 0.877778 12.958 0 10.2002 0C6.19464 0 2.69464 2.55556 1.15686 5.61111L4.50131 8.24444C5.28909 5.84444 7.53909 3.84444 10.2002 3.84444Z"
      fill="#EA4335"
    />
  </svg>
);

export const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
      fill="#6B7280"
    />
  </svg>
);
